export default __webpack_public_path__ + "static/media/gradient_bg_01.9de498ae.jpg";